"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSlidingSidePanel = _interopRequireDefault(require("react-sliding-side-panel"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _closeIcon = _interopRequireDefault(require("./assets/close-icon.svg"));

require("./assets/styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 16px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transition-duration: 0.25s;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 400;\n  color: rgba(57, 57, 57, 0.6);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Roboto', sans-serif;\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 400;\n  color: rgba(57, 57, 57, 0.87);\n  margin-bottom: 0px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 22px;\n  grid-column-gap: 16px;\n  padding: 16px;\n  /* background-color: #f8f8f8; */\n  /* border-bottom: 1px solid rgba(127, 127, 127, 0.15); */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SLSlidingPanel = function SLSlidingPanel(props) {
  return _react.default.createElement(_reactSlidingSidePanel.default, {
    size: props.size,
    type: props.type,
    isOpen: props.isOpen,
    backdropClicked: props.onClose
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Header, null, _react.default.createElement(TitleGroup, null, props.title && _react.default.createElement(Title, null, props.title), props.subtitle && _react.default.createElement(Subtitle, null, props.subtitle)), _react.default.createElement(CloseButton, null, _react.default.createElement(CloseButtonImage, {
    alt: "",
    src: _closeIcon.default,
    width: 22,
    height: 22,
    onClick: props.onClose
  }))), _react.default.createElement(Main, null, props.children)));
};

SLSlidingPanel.defaultProps = {
  type: 'right',
  size: 35,
  children: _react.default.createElement("div", {
    style: {
      color: '#ccc'
    }
  }, "No content provided")
};

var Header = _styledComponents.default.header(_templateObject());

var TitleGroup = _styledComponents.default.div(_templateObject2());

var Title = _styledComponents.default.h2(_templateObject3());

var Subtitle = _styledComponents.default.h3(_templateObject4());

var CloseButton = _styledComponents.default.div(_templateObject5());

var CloseButtonImage = _styledComponents.default.img(_templateObject6());

var Main = _styledComponents.default.main(_templateObject7());

var _default = SLSlidingPanel;
exports.default = _default;

//# sourceMappingURL=SLSlidingPanel.js.map